module.exports = __webpack_public_path__ + "img/dropdown-menu-product-3-1.ae8035fe.png";